import HolidayProgramBookingJson from './HolidayProgramBookingJson';
import HolidayProgramPriceJson, { validateHolidayProgramPriceJson } from './HolidayProgramPriceJson';
import { Validation } from './Validation';

export default interface HolidayProgramJson {
   ID: number | null,

   /**
    * Kurzbeschreibung des Programms.
    */
   title: string,

   /**
    * Beschreibung des Programms.
    */
   description: string;

   /**
    * Besondere Hinweise die für dieses Programm gelten. Kann ein leerer String sein wenn nichts besonderes gilt.
    */
   remarks: string;

   /**
    * Datum des ersten Tags der Ferienbetreuung.
    */
   beginDate: string;

   /**
    * Datum des letzten Tags der Ferienbetreuung.
    */
   endDate: string;

   /**
    * Basispreis zu dem dieses Programm angeboten wird ohne irgendwelche Vergünstigungen.
    */
   basePrice: HolidayProgramPriceJson;

   /**
    * Rabattpreise und vergünstigungen zu dem dieses Programm angeboten wird ohne irgendwelche Vergünstigungen.
    */
   discountPrices: HolidayProgramPriceJson[];

   /**
    * Preise für Addons wie Frühbetreuung.
    */
   addonPrices: HolidayProgramPriceJson[];

   /**
    * Gibt an ob die Registrierungen für die Ferienbetreuung fregegeben sind. 
    * Wenn es auf true ist, werden immer noch registrationBeginDate und registrationEndDate sowie registrationMaximumCount beachtet.
    */
   allowRegistration: boolean;

   /**
    * Datum und Uhrzeit ab dem Registrierungen möglich sind.
    */
   registrationBeginDateTime: string;

   /**
    * Datum und Uhrzeit bis zu dem Registrierungen möglich sind.
    */
   registrationEndDateTime: string;

   /**
    * Maximale Anzahl an Teilnehmern die akzeptiert werden.
    */
   registrationMaximumCount: number;

   /**
    * Maximale Anzahl an Teilnehmern die in der Warteliste akzeptiert werden. Kann 0 sein.
    */
   waitingListMaximumCount: number;

   /**
    * Gibt für das Kunden-Buchungsformular an, welches Mindestalter die Kinder für das Programm haben sollten. Kann null sein, falls keine Einschränkung besteht.
    */
   restrictMinimumAge: number | null;

   /**
    * Gibt für das Kunden-Buchungsformular an, welches Maximalalter die Kinder für das Programm haben sollten. Kann null sein, falls keine Einschränkung besteht.
    */
   restrictMaximumAge: number | null;
}

export type HolidayProgramWithBookingsJson = HolidayProgramJson & { "bookings": HolidayProgramBookingJson[]; };
export type HolidayProgramWithBookingJson = HolidayProgramJson & { "booking": HolidayProgramBookingJson; };
export type HolidayProgramInfoJson = HolidayProgramJson & { "registrationSlotsFree": number, "waitingListSlotsFree": number; };

export const HolidayProgramDescriptionAllowedTags: string[] = ["p", "br", "b", "ul", "li", "u"];

export function validateHolidayProgramJsonAddNew(item: HolidayProgramJson) {
   return new Validation(item)
      .validateEquals("ID", null)
      .validateNonEmptyString("title", 100)
      .validateString("description", 1500)
      .validateString("remarks", 500)
      .validateDate("beginDate")
      .validateDateLater("endDate", "beginDate")
      .validateUsingFunction("basePrice", validateHolidayProgramPriceJson, false)
      .validateAllUsingFunction("discountPrices", validateHolidayProgramPriceJson)
      .validateAllUsingFunction("addonPrices", validateHolidayProgramPriceJson)
      .validateInteger("registrationMaximumCount", 0)
      .validateInteger("restrictMinimumAge", 0, 120, true)
      .validateInteger("restrictMaximumAge", 0, 120, true)
      .finish();
}
export function validateHolidayProgramJson(item: HolidayProgramJson) {
   return new Validation(item)
      .validateInteger("ID", 0)
      .validateNonEmptyString("title", 100)
      .validateString("description", 1500)
      .validateString("remarks", 500)
      .validateDate("beginDate")
      .validateDateLater("endDate", "beginDate")
      .validateUsingFunction("basePrice", validateHolidayProgramPriceJson, false)
      .validateAllUsingFunction("discountPrices", validateHolidayProgramPriceJson)
      .validateAllUsingFunction("addonPrices", validateHolidayProgramPriceJson)
      .validateInteger("registrationMaximumCount", 0)
      .validateInteger("restrictMinimumAge", 0, 120, true)
      .validateInteger("restrictMaximumAge", 0, 120, true)
      .finish();
}